import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";

import { InfoPopover } from "./InfoPopover";
import { ItemInfoCard } from "./ItemInfoCard";

type ItemInfoProps = {
  itemId: number;
  // Название предмета — для подписи кнопки экранному диктору.
  name: string;
  // Иконка предмета: становится кнопкой.
  children: ReactNode;
  // Плашка под названием — зачем предмет здесь: «Ослабить врага · режет лечение».
  note?: ReactNode;
  // Строка внизу описания, своя у каждого места: например, доля сильных в сборке.
  footer?: ReactNode;
  className?: string;
};

// Иконка предмета, которая показывает его описание: на компьютере — окном у иконки при
// наведении (нажатие закрепляет), на телефоне — шторкой снизу по нажатию.
export const ItemInfo = ({ itemId, name, children, note, footer, className }: ItemInfoProps) => {
  const { t } = useLingui();
  return (
    <InfoPopover
      label={t`Description of ${name}`}
      title={name}
      className={className}
      renderCard={({ renderTitle, closeButton }) => (
        <ItemInfoCard
          itemId={itemId}
          note={note}
          footer={footer}
          renderTitle={renderTitle}
          closeButton={closeButton}
        />
      )}
    >
      {children}
    </InfoPopover>
  );
};
